import React from 'react';
import { Container, Row, Col,Card, CardHeader, CardBody } from 'reactstrap';
import logo from './UwoChampsLogo.png';
import ResultsCard from './components/results/ResultsCard';
import CompetitionDay from './components/CompetitionDay';
import { CompetitionDay as CompetitionDayData, StartListData } from './data/StartLIstData';
import { DisciplineResults } from './model/Results';
import reviver from './utils/reviver';
import { StartList } from './model/StartList';
import StartListCard from './components/startlist/StartListCard';
import date from 'date-and-time';
import { Bracket, IRoundProps } from 'react-brackets';

const junWomen: IRoundProps[] = [
  {
    title: 'Round one',
    seeds: [
      {
        id: 1,
        date: new Date().toDateString(),
        teams: [{ name: 'KLABUNDE Lotte' }, { name: '' }],
      },
      {
        id: 2,
        date: new Date().toDateString(),
        teams: [{ name: 'RENDES Linda' }, { name: 'IVETIČ Ema' }],
      },
      {
        id: 3,
        date: new Date().toDateString(),
        teams: [{ name: 'DESPOTOVIČ Iris' }, { name: 'MARČELJA Tina' }],
      },
      {
        id: 4,
        date: new Date().toDateString(),
        teams: [{ name: 'STEIN Franziska' }, { name: 'KRASNOKUTSKA Viktoriia' }],
      }
    ],
  },
  {
    title: 'Semifinals',
    seeds: [
      {
        id: 5,
        date: new Date().toDateString(),
        teams: [{ name: 'Team A' }, { name: 'Team C' }],
      },
      {
        id: 6,
        date: new Date().toDateString(),
        teams: [{ name: 'Team A' }, { name: 'Team ' }],
      }
    ],
  },
  {
    title: 'Finals',
    seeds: [
      {
        id: 7,
        date: new Date().toDateString(),
        teams: [{ name: 'Team A' }, { name: 'Team C' }],
      }
    ],
  }
];

function App() {
  const [currentTime, setDate] = React.useState(new Date());
  const [competitionDayData, setCompetitionDayData] = React.useState<DisciplineResults[]>([]);

  React.useEffect(() => {
    const api = async () => {
      await fetch(`https://championshipdata.blob.core.windows.net/results/results.json`, { method: 'GET' })
        .then(x => x.json())
        .then(x => setCompetitionDayData(x));      
    };
    api();

    var timerID = setInterval(() => tick(), 15000);

    return function cleanup() {
      clearInterval(timerID);
    };
  });

  function tick() {
    setDate(new Date());
  }

  const data = startLists();
  
  return (
    <Container fluid={false}>
      <Row>
        <Col>
          <img src={logo} />
        </Col>
      </Row>      
      <Row>
        <Col>
          {
            competitionDayData
              .filter(x => x.Results.length > 0)
              .map(x => <>
                <ResultsCard Results={x} />
                <br />
                <br />
              </>)
          }
        </Col>
      </Row>
      <Row>
        <Col>
          {
            data
              .filter(x => x.StartListRows
                .filter(r => date.subtract(r.StartTime, currentTime).toSeconds() > 0).length > 0)
              .map(x => <>
                <StartListCard CurrentTime={currentTime} StartList={x} />
                <br />
                <br />
              </>)
          }
        </Col>
      </Row>
    </Container >
  );
}

const startLists = () => {
  const data: StartList[] = JSON.parse(
    `[
        {"Discipline":"TEAM EVENT MEN","StartListRows":[{"StartTime":"2023-08-19T09:00","Nation":"Gerrmany","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Wilfried","LastName":"KRAUSE","Born":"1990"},"Athlete2":{"Start":"S2","FirstName":"Johannes","LastName":"BÖHME","Born":"1987"},"Athlete3":{"Start":"S3","FirstName":"Wenzel","LastName":"SCHLEY","Born":"2003"},"Athlete4":{"Start":"S4","FirstName":"Finn","LastName":"MALCHOW","Born":"2004"}}},{"StartTime":"2023-08-19T09:10","Nation":"Estonia","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Vladimir","LastName":"KUNITSÕN","Born":"1987"},"Athlete2":{"Start":"S2","FirstName":"Nikolai","LastName":"TOVER","Born":"1982"},"Athlete3":{"Start":"S3","FirstName":"Roman","LastName":"JOTAUTAS","Born":"1981"},"Athlete4":{"Start":"S4","FirstName":"Georg","LastName":"VEEVO","Born":"2004"}}},{"StartTime":"2023-08-19T09:20","Nation":"Czech Republic","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Martin","LastName":"ŠMEJKAL","Born":"1992"},"Athlete2":{"Start":"S2","FirstName":"Jakub","LastName":"VALNÍČEK","Born":"1996"},"Athlete3":{"Start":"S3","FirstName":"Matěj","LastName":"NOVOTNÝ","Born":"2004"},"Athlete4":{"Start":"S4","FirstName":"Jakub","LastName":"NĚMEČEK","Born":"1984"}}},{"StartTime":"2023-08-19T09:30","Nation":"Italy","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Marco","LastName":"CAMPANILE","Born":"1999"},"Athlete2":{"Start":"S2","FirstName":"Giovanni","LastName":"BENEDETTI","Born":"2004"},"Athlete3":null,"Athlete4":null}},{"StartTime":"2023-08-19T09:40","Nation":"Hungary","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Kelen","LastName":"CSÉPLÖ","Born":"2003"},"Athlete2":{"Start":"S2","FirstName":"Péter","LastName":"BALÁZS","Born":"1976"},"Athlete3":{"Start":"S3","FirstName":"Tamás","LastName":"SZÁSZ","Born":"2001"},"Athlete4":{"Start":"S4","FirstName":"Vendel","LastName":"VÁRSZEGI","Born":"1998"}}},{"StartTime":"2023-08-19T09:50","Nation":"France","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Yan","LastName":"PLÖTZE","Born":"2001"},"Athlete2":{"Start":"S2","FirstName":"Julien","LastName":"SEBIRE","Born":"1983"},"Athlete3":{"Start":"S3","FirstName":"Bastien","LastName":"JEHL","Born":"2006"},"Athlete4":{"Start":"S4","FirstName":"Tino","LastName":"PLÖTZE","Born":"2003"}}},{"StartTime":"2023-08-19T10:00","Nation":"Ukraine","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Maksym","LastName":"KOTOV","Born":"1987"},"Athlete2":{"Start":"S2","FirstName":"Anton","LastName":"MYKHAILOV","Born":"1987"},"Athlete3":null,"Athlete4":null}},{"StartTime":"2023-08-19T10:10","Nation":"Croatia","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Robert","LastName":"ČUPEV","Born":"1976"},"Athlete2":{"Start":"S2","FirstName":"Luka","LastName":"BOHAČ","Born":"2004"},"Athlete3":{"Start":"S3","FirstName":"Patrick","LastName":"LIKER","Born":"2004"},"Athlete4":{"Start":"S4","FirstName":"Josip","LastName":"ŠTEFANIČ","Born":"1995"}}}]},
        {"Discipline":"TEAM EVENT WOMEN","StartListRows":[{"StartTime":"2023-08-19T10:20","Nation":"Gerrmany","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Lisa","LastName":"DETHLOFF","Born":"1998"},"Athlete2":{"Start":"S2","FirstName":"Theresa","LastName":"KÖHN","Born":"2000"},"Athlete3":{"Start":"S3","FirstName":"Johanna","LastName":"KÖHN","Born":"1998"},"Athlete4":{"Start":"S4","FirstName":"Anika","LastName":"HASSE","Born":"1988"}}},{"StartTime":"2023-08-19T10:30","Nation":"Kazakchstan","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Shokhnoza","LastName":"KURBANOVA","Born":"1989"},"Athlete2":{"Start":"S2","FirstName":"Lyudmila","LastName":"SHUMILOVA","Born":"1969"},"Athlete3":null,"Athlete4":null}},{"StartTime":"2023-08-19T10:40","Nation":"Czech Republic","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Barbora","LastName":"SVOBODOVÁ","Born":"2001"},"Athlete2":{"Start":"S2","FirstName":"Zuzana","LastName":"DVOŘÁKOVÁ","Born":"1975"},"Athlete3":{"Start":"S3","FirstName":"Dominika","LastName":"BENEŠOVÁ","Born":"1999"},"Athlete4":{"Start":"S4","FirstName":"Kristýna","LastName":"JANOUŠKOVÁ","Born":"1998"}}},{"StartTime":"2023-08-19T10:50","Nation":"Italy","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Beatrice","LastName":"SERRA","Born":"2004"},"Athlete2":{"Start":"S2","FirstName":"Chiara","LastName":"BRUNENGHI","Born":"1996"},"Athlete3":{"Start":"S3","FirstName":"Martina","LastName":"MORI","Born":"2000"},"Athlete4":null}},{"StartTime":"2023-08-19T11:00","Nation":"Hungary","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Anna","LastName":"VIRÁG","Born":"2005"},"Athlete2":{"Start":"S2","FirstName":"Linda","LastName":"RENDES","Born":"2003"},"Athlete3":{"Start":"S3","FirstName":"Katalin","LastName":"HATHÁZI","Born":"1977"},"Athlete4":{"Start":"S4","FirstName":"Liliána","LastName":"TAKÁCS","Born":"2005"}}},{"StartTime":"2023-08-19T11:10","Nation":"France","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Florence","LastName":"PLÖTZE","Born":"1969"},"Athlete2":{"Start":"S2","FirstName":"Anne-Charlotte","LastName":"CALLET","Born":"2003"},"Athlete3":null,"Athlete4":null}},{"StartTime":"2023-08-19T11:20","Nation":"Ukraine","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Mariia","LastName":"KUZMINA","Born":"1986"},"Athlete2":{"Start":"S2","FirstName":"Viktoriia","LastName":"KRASNOKUTSKA","Born":"2005"},"Athlete3":null,"Athlete4":null}},{"StartTime":"2023-08-19T11:30","Nation":"Croatia","Competitor":{"Kind":"Team","Athlete1":{"Start":"S1","FirstName":"Saša","LastName":"MILOŠ","Born":"1981"},"Athlete2":{"Start":"S2","FirstName":"Lea","LastName":"ČUPEV","Born":"1981"},"Athlete3":{"Start":"S3","FirstName":"Iris","LastName":"DESPOTOVIČ","Born":"2002"},"Athlete4":{"Start":"S4","FirstName":"Ema","LastName":"IVETIČ","Born":"2002"}}}]}
  ]`, reviver)

  return data;
};

export default App;
